import { render, staticRenderFns } from "./FormularioPagoComponent.vue?vue&type=template&id=5b13d157"
import script from "./FormularioPagoComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioPagoComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports